import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Link from 'next/link';
import moment from 'moment-timezone';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { subcribeToNewsletter, createContactAddToListFromFooter } from '../../redux/actions';
import { Facebook, Instagram, Vimeo, LinkedIn, Logo } from '../../utils';

import {
  FooterTag,
  FooterLogo,
  FooterSectionContainer,
  FooterSection,
  FooterSectionHeading,
  FooterList,
  FooterItem,
  FooterSocial,
  EmailContainer,
  EmailInput,
  EmailButton,
  DiscountMessage,
  SocialsList,
  SocialsItem,
  CopyrightContainer,
  Copyright,
  CopyrightList,
  EmailError,
  SubmitStatus,
  EmailSuccess,
  Wrapper,
  ErrorWrapper,
  ErrorMessage,
  SuccessMessage
} from './styles';

const EmailSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Email is required')
});

const Footer = ({ isInnerPage, subscription, handleEmailSubmit, createContactAddToListFromFooter, checkout, activeCampaign }) => (
  <FooterTag isInnerPage={isInnerPage} checkout={checkout}>
    {!checkout && (
      <FooterSectionContainer isInnerPage={isInnerPage}>
        {isInnerPage && (
          <FooterLogo>
            <Link href="/">
              <a>
                <Logo width="100%" height="100%" color={isInnerPage ? '#1eb6ff' : '#ffffff'}/>
              </a>
            </Link>
          </FooterLogo>
        )}
        <FooterSection>
          <FooterSectionHeading>Dayaxe</FooterSectionHeading>
          <FooterList>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/how-it-works">How It Works</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/press">Press</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/contact-us">Help</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/contact-us">Contact Us</a>
            </FooterItem>
          </FooterList>
        </FooterSection>
        <FooterSection>
          <FooterSectionHeading>Discover</FooterSectionHeading>
          <FooterList>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/goldpass">Gold Pass</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/giftcards">Gift Card</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/referral">Free Daycations</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/cities">Cities</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/resorts">Resorts</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.blog.dayaxe.com/">Blog</a>
            </FooterItem>
          </FooterList>
        </FooterSection>
        <FooterSection>
          <FooterSectionHeading>Partners</FooterSectionHeading>
          <FooterList>
            <FooterItem>
              <a href="http://hotels.dayaxe.com">Partner Home Page</a>
            </FooterItem>
            <FooterItem>
              <a href="https://portal.dayaxe.com/">Partner Login</a>
            </FooterItem>
            <FooterItem>
              <a href="https://www.hotels.dayaxe.com/#contac-us">Partner Sign Up</a>
            </FooterItem>
          </FooterList>
        </FooterSection>
        <FooterSection>
        <SocialsList>
              {/* <SocialsItem>
                <a href="http://www.facebook.com/dayaxeapp">
                  <Facebook width={11} height={20} />
                </a>
              </SocialsItem> */}
              <SocialsItem>
                <a href="http://www.instagram.com/dayaxeapp">
                  <Instagram width={20} height={20} />
                </a>
              </SocialsItem>
              {/* <SocialsItem>
                <a href="https://vimeo.com/dayaxe">
                  <Vimeo width={20} height={16} />
                </a>
              </SocialsItem> */}
              {/* <SocialsItem>
                <a href="https://www.linkedin.com/company/dayaxe.com">
                  <LinkedIn width={19} height={18} />
                </a>
              </SocialsItem> */}
            </SocialsList>
        </FooterSection>
        {/* <FooterSection>
          <FooterSectionHeading>New resorts launched & special offers</FooterSectionHeading>
          <FooterSocial>
            <Formik
              initialValues={{
                email: '',
                name: ''
              }}
              validationSchema={EmailSchema}
              onSubmit={values => createContactAddToListFromFooter(values.name, values.email)}
            >
              {({ errors, touched, handleBlur, handleChange, values }) => {
                return (
                  <EmailContainer>
                    <Wrapper>
                      <EmailInput
                        type="text"
                        placeholder="Enter name..."
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.name}
                      />

                      <EmailInput
                        type="email"
                        placeholder="Enter email..."
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.email}
                      />
                    </Wrapper>
                    <ErrorWrapper>
                      {errors.name && touched.name && <ErrorMessage>{errors.name}</ErrorMessage>}
                      {errors.email && touched.email && <ErrorMessage>{errors.email}</ErrorMessage>}
                    </ErrorWrapper>
                    <Wrapper>
                      <EmailButton btnType="primary" type="submit">
                        {activeCampaign.footerStatus == "fetching" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="loader"
                            preserveAspectRatio="xMidYMid"
                            style={{ width: '60px', height: '20px' }}
                            viewBox="0 0 68 14"
                          >
                            <g transform="translate(7 7)">
                              <circle r="7" fill="#ffffff" transform="scale(0.8984)">
                                <animateTransform
                                  attributeName="transform"
                                  begin="-0.375s"
                                  calcMode="spline"
                                  dur="1s"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  keyTimes="0;0.5;1"
                                  repeatCount="indefinite"
                                  type="scale"
                                  values="0;1;0"
                                />
                              </circle>
                            </g>
                            <g transform="translate(27 7)">
                              <circle r="7" fill="#ffffff" transform="scale(0.59269)">
                                <animateTransform
                                  attributeName="transform"
                                  begin="-0.25s"
                                  calcMode="spline"
                                  dur="1s"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  keyTimes="0;0.5;1"
                                  repeatCount="indefinite"
                                  type="scale"
                                  values="0;1;0"
                                />
                              </circle>
                            </g>
                            <g transform="translate(47 7)">
                              <circle r="7" fill="#ffffff" transform="scale(0.2416)">
                                <animateTransform
                                  attributeName="transform"
                                  begin="-0.125s"
                                  calcMode="spline"
                                  dur="1s"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  keyTimes="0;0.5;1"
                                  repeatCount="indefinite"
                                  type="scale"
                                  values="0;1;0"
                                />
                              </circle>
                            </g>
                          </svg>
                        ) : 'Sign Up'}
                      </EmailButton>
                      <DiscountMessage>
                        <span>+15%</span> off promo
                      </DiscountMessage>
                    </Wrapper>
                  </EmailContainer>
                )
              }
              }
            </Formik>
            {
              activeCampaign.footerStatus == "failure" &&
              <ErrorMessage>
                {activeCampaign.footerError}
              </ErrorMessage>
            }
            {
              activeCampaign.footerStatus == "success" &&
              <SuccessMessage>
                Successfully added to the list.
              </SuccessMessage>
            }
          
          </FooterSocial>
        </FooterSection> */}
      </FooterSectionContainer>
    )}
    <CopyrightContainer checkout={checkout}>
      <FooterSectionContainer isInnerPage={isInnerPage}>
        <Copyright>© {moment().format('YYYY')} Dayaxe. All rights reserved.</Copyright>
        {!checkout && (
          <CopyrightList>
            <li>
              <Link href="/terms">
                <a target="_blank" rel="noopener noreferrer">Terms</a>
              </Link>
            </li>
            <li>
              <Link href="/privacy-policy">
                <a target="_blank" rel="noopener noreferrer">Privacy</a>
              </Link>
            </li>
            <li>
              <a href="https://www.dayaxe.com/sitemap">Sitemap</a>
            </li>
          </CopyrightList>
        )}
      </FooterSectionContainer>
    </CopyrightContainer>
  </FooterTag>
);

Footer.propTypes = {
  isInnerPage: PropTypes.bool,
  subscription: PropTypes.instanceOf(Object),
  handleEmailSubmit: PropTypes.func,
  checkout: PropTypes.bool,
};

const mapStateToProps = state => ({
  subscription: state.emailSubscription,
  activeCampaign: state.activeCampaign,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  // handleEmailSubmit: subcribeToNewsletter,
  createContactAddToListFromFooter: createContactAddToListFromFooter
}, dispatch);

export default memo(connect(mapStateToProps, mapDispatchToProps)(Footer));
